// @flow

import styled from 'styled-components';

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  cursor: pointer;
  /* stylelint-disable-next-line property-no-unknown */
  accent-color: var(--wlc-highlight-color);
`;
